import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./emergency.css";
import { scAxios, scAxiosAdmin } from "../..";

const sendemailforreset = (url, data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(url, {
      method: "post",
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

class ForgotPass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      loading: false,
      error: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value, error: "", success: false });
  }

  handleSubmit(event) {
    event.preventDefault();
    // const { email } = this.state;
    this.setState({ loading: true });
    const data = {
      email: this.state.email,
      base_url: window.location.origin
    };

    sendemailforreset("/forgetpassword", data)
      .then((response) => {
        this.setState({ loading: false });
        console.log(response);
        if (response.status) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        this.setState({ error, loading: false });
      });

    // this.setState({ success: true });
  }

  // ERP API
  // handleSubmit(event) {
  //     event.preventDefault();
  //     // const { email } = this.state;
  //     this.setState({ loading: true });
  //     const data = { email: this.state.email };

  //     sendemailforreset('forgetpassword',data)
  //         .then(response => {
  //             this.setState({ loading: false });
  //             console.log(response)
  //             if(response.status){
  //                 toast.success(response.message)
  //             }
  //             else{
  //                 toast.error(response.message)
  //             }
  //         })
  //         .catch(error => {
  //             this.setState({ error, loading: false });
  //         });

  //     // this.setState({ success: true });
  // }

  render() {
    const { email, loading, error, success } = this.state;

    // if (loading) {
    //     return <div>Loading...</div>;
    // }

    // if (error) {
    //     return <div>Error: {error.message}</div>;
    // }

    return (
      <div className="borders">
        <form className="form-content" onSubmit={this.handleSubmit}>
          <h5 className="text-center">Forgot Password</h5>
          <div className="mb-3">
            <label for="exampleInputEmail1" className="form-label">
              Email address
            </label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={email}
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              onChange={this.handleInputChange}
              required
            />
            <div id="emailHelp" className="form-text"></div>
          </div>

          {loading ? <p>Loading! Please wait...</p> : null}

          <button type="submit" className="butttons">
            Send your email
          </button>
          <a href="/">Back to home</a>
        </form>
        <ToastContainer autoClose={5000} />
      </div>
    );
  }
}

export default ForgotPass;



// WEBPACK FOOTER //
// ./src/component/frontend/ForgotPass.js